import minilog from 'minilog';

minilog.enable();

const logo = '\n' +
    '///////////////////////////////////////////////////////////\n' +
    '///////////////////////////////////////////////////////////\n' +
    '////////////////////////////*,/////////////////////////////\n' +
    '//////////////////////////*.   ,///////////////////////////\n' +
    '/////////////////////*.             ,*/////////////////////\n' +
    '/////////////////*.                     ,//////////////////\n' +
    '//////////////*.    .---/./.-./---/--/.    ,*//////////////\n' +
    '////////////*    .////*,.         .,////*.    *////////////\n' +
    '///////////,   .*//*,     ..,,,.      ,*//*    ,///////////\n' +
    '/////////,.  .///,   .*/////////////*    *///   .*/////////\n' +
    '////////*   .///.  .*///*.       .,///,.  ,///    /////////\n' +
    '////////   .//,   ///*    .*****.    *//*..,///   .////////\n' +
    '///////,   //*   //*.  ,////***////,  ,*///////*   ,///////\n' +
    '///////   .//.  ,//   *//*      .///,        ,//   .///////\n' +
    '//////*   ,//   //,  .//*  ,///.  ,//   .,,  .//.   ///////\n' +
    '//////*   ,//   //,  ,//*  *///,  .//.  */*   //,   ///////\n' +
    '///////   ,//         ///.       .*/*   //,  .//.  .///////\n' +
    '///////.   ////////,  .///      .///  .*//   */*   ,///////\n' +
    '///////*   ,////////*  ,//*     *//. .///.  .//.   *///////\n' +
    '////////,   *//*  .///*.,//,   *//*,///*   *//,   *////////\n' +
    '/////////.   *//*   .*//////,.,//////*    ///*   ./////////\n' +
    '//////////*   .*//*    ..*///////*,    .*//,.   ///////////\n' +
    '///////////*    .////,    ./. ./    .,////.   .////////////\n' +
    '/////////////*     ,*///////**////////*,    .*/////////////\n' +
    '////////////////*.      .,*******,.      .*////////////////\n' +
    '///////////////////,.                 ,*///////////////////\n' +
    '////////////////////////*,      .,*////////////////////////\n' +
    '///////////////////////////*. .////////////////////////////\n' +
    '///////////////////////////////////////////////////////////';

const logger = minilog('gui');

const printLogo = () => {
    logger.info(logo);
};

export {
    printLogo,
    logger as default
};
